import { RcFile } from "antd/es/upload";

import { axios, persistentQueryClient } from "utils";

import { ADMIN_CARBON_PROGRAM_URL, GET_PROGRAM_CONTRACTS_ADMIN } from "consts";

import {
  CarbonProgram,
  CarbonProgramOutcomesResponse,
  CarbonProgramParticipation,
  CarbonProgramParticipationRequest,
  IncentivesPotentialPayouts,
  ProgramContract,
} from "models";

interface GetFarmsParams {
  params: {
    limit: number;
    page: number;
    name?: string;
    carbonProgramId?: string;
  };
}

export const getAllCarbonPrograms = async (): Promise<CarbonProgram[]> => axios.get(ADMIN_CARBON_PROGRAM_URL);

export const getFarmsByCarbonProgram = async ({ params }: GetFarmsParams): Promise<{ participations: CarbonProgramParticipation[]; count: number }> =>
  axios.get(`${ADMIN_CARBON_PROGRAM_URL}/farms`, { params });

export const getCarbonProgramByFarmIdAdmin = async (farmId?: string): Promise<CarbonProgram> =>
  // @ts-expect-error custom params can be passed in axios config
  axios.get(`${ADMIN_CARBON_PROGRAM_URL}/farms/${farmId}`, { hideErrorMessage: true });

export const addOrUpdateProgramParticipation = async (data: CarbonProgramParticipationRequest): Promise<CarbonProgramParticipation> =>
  axios.put(`${ADMIN_CARBON_PROGRAM_URL}/farms`, { data });

export const getProgramContracts = async (programId: string): Promise<ProgramContract[]> => axios.get(`${ADMIN_CARBON_PROGRAM_URL}/${programId}/contracts`);

const uploadProgramContract = async (data: { programId: string; file: string | ArrayBuffer | null }): Promise<{ filename: string }> =>
  axios.post(`${ADMIN_CARBON_PROGRAM_URL}/${data.programId}/contracts`, { data });

export const updateProgramContract = async (data: { programId: string; file: RcFile }) => {
  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.readAsDataURL(data.file);

    reader.onerror = () => {
      reader.abort();
      reject(new DOMException("Problem parsing input file."));
    };

    reader.onload = () => {
      uploadProgramContract({
        file: reader.result,
        programId: data.programId,
      }).then((res) => {
        persistentQueryClient.invalidateQueries({ queryKey: [GET_PROGRAM_CONTRACTS_ADMIN, data.programId] });
        resolve(res);
      });
    };
  });
};

export const getCarbonProgramOutcomesAdmin = async (data: { fieldIds: string[] }): Promise<CarbonProgramOutcomesResponse> =>
  axios.post(`${ADMIN_CARBON_PROGRAM_URL}/run`, { data });

export const getIncentivesPotentialPayoutsAdmin = async (data: { farmId: string }): Promise<IncentivesPotentialPayouts> =>
  axios.get(`${ADMIN_CARBON_PROGRAM_URL}/farms/${data.farmId}/incentives-potential-payouts`);
